import styled from 'styled-components';
import React from 'react';

export const Container = styled.div`
  padding: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
